import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { formatDate, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { WebcamModule } from 'ngx-webcam';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatNativeDateModule,
  MatTableModule,
  MatPaginatorModule, 
  MatPaginator,
  MatIconModule,
  MatRadioModule
} from '@angular/material';

//tabs del home
import {MatTabsModule} from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatToolbarModule} from '@angular/material/toolbar';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FileSelectDirective} from 'ng2-file-upload';
import { FileUploadModule } from 'ng2-file-upload';
import {FooterComponent} from './pages/footer/footer.component';
import {NavbarComponent} from './pages/shared/navbar/navbar.component';
import {CuitInputComponent} from './pages/shared/cuit-input/cuit-input.component';
import {AppComponent} from './app.component';
import {HomeComponent} from './pages/home/home.component';
import {ReportesComponent} from './pages/reportes/reportes.component';
import { LoginComponent } from './pages/login/login.component';
import { HttpModule } from '@angular/http';
import {HttpClientModule} from "@angular/common/http";
import { NuevogastoComponent } from './pages/nuevogasto/nuevogasto.component';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//servicios
import { AuthService } from './servicios/auth.service';
import { AuthGuardService } from './servicios/auth-guard.service';
import { UserService } from './servicios/user.service';

//guards
import { UserGuardService } from "./servicios/guards/user-guard.service";
import { MultiUserGuardService } from "./servicios/guards/multi-user.service";
import { PagosUserGuardService } from "./servicios/guards/pagos-user.service";
import { AdminGuardService } from "./servicios/guards/admin-guard.service";
import { DelegadoGuardService } from "./servicios/guards/delegado-guard.service";
import { JorgeGuardService } from "./servicios/guards/jorge-guard.service";
import { ContadorGuardService } from "./servicios/guards/contador-guard.service";

//coponentes
import { VergastosComponent } from './pages/vergastos/vergastos.component';
import { VerdetallesComponent } from './pages/vergastos/verdetalles/verdetalles.component';
import { VerdetalleComponent } from './pages/vergastos/verdetalles/verdetalle/verdetalle.component';
import { VergastosPagosComponent } from './pages/pagos/vergastos-pagos/vergastos-pagos.component';
import { VerdetallesPagosComponent } from './pages/pagos/vergastos-pagos/verdetalles-pagos/verdetalles-pagos.component';
import { LoadingComponent } from './pages/shared/loading/loading.component';
import { ChanguepassComponent } from './pages/changuepass/changuepass.component';
import { JorgeComponent } from './pages/jorge/jorge.component';

//snackbar
import { MatSnackBarModule } from '@angular/material/snack-bar';
//datepicker en argent
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter'
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
//localeid
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';

// importar locales
import localePy from '@angular/common/locales/es-PY';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeEsAr from '@angular/common/locales/es-AR';

import {Subject} from 'rxjs';
import { Observable } from 'rxjs';

//pipes
import { CategoryFilterPipe } from "./pages/shared/pipes/category.pipe";
import { DetallesJorgeComponent } from './pages/jorge/detalles-jorge/detalles-jorge.component';
import { PrintComponent } from './pages/shared/print/print.component';
import { PrintGastosComponent } from './pages/shared/print/print-gastos/print-gastos.component';
import { ContadorComponent } from './pages/contador/contador.component';

//carousel
import { Ng2CarouselamosModule  } from "ng2-carouselamos";

//service historico
import { GLOBALService } from './servicios/functions/GLOBAL.service';
import { NuevofondofijoComponent } from './pages/nuevofondofijo/nuevofondofijo.component';
import { NuevaopComponent } from './pages/nuevaop/nuevaop.component';
import { PlandecuentasComponent } from './pages/contador/plandecuentas/plandecuentas.component';
import { ImpresionOpComponent } from './pages/nuevaop/impresion-op/impresion-op.component';
import { VeropComponent } from './pages/nuevaop/verop/verop.component';
import { CGComponent } from './pages/cg/cg.component';
import { NgQrScannerModule } from 'angular2-qrscanner';
import { SpellCheckerModule } from 'ngx-spellchecker';
import { CargaComponent } from './pages/sideu/carga/carga.component';
import { SinomytComponent } from './pages/sinomyt/sinomyt.component';
import { EmpresasComponent } from './pages/sideu/empresas/empresas.component';
import { ConsultaComponent } from './pages/sideu/consulta/consulta.component';
import { ImportadorComponent } from './pages/importador/importador.component';
import { ImportadorallComponent } from './pages/importadorall/importadorall.component';
import { ImportadorallTransfComponent } from './pages/importadorall-transf/importadorall-transf.component';
import { ReporteDeudasComponent } from './pages/reporte-deudas/reporte-deudas.component';
import { ReporteBeneficiariosComponent } from './pages/reporte-beneficiarios/reporte-beneficiarios.component';
import { LiquidacionesComponent } from './pages/liquidaciones/liquidaciones.component';
import { LiquidacionesGuardadasComponent } from './pages/liquidaciones-guardadas/liquidaciones-guardadas.component';
import { CrearEmpresaDialogComponent } from './pages/liquidaciones/crear-empresa-dialog.component';
import { ConfiguracionComponent } from './pages/configuracion/configuracion.component';
import { PorcentajesComponent } from './pages/configuracion/porcentajes/porcentajes.component';
import { VencimientosComponent } from './pages/configuracion/vencimientos/vencimientos.component';
import { TextoLegalComponent } from './pages/configuracion/texto-legal/texto-legal.component';

// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localePy, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en')
//registerLocaleData(localeEsAR, 'es-Ar');


const appRoutes: Routes = [
  { path: 'home', component: HomeComponent },
  {
    path: 'reportes',
    component: ReportesComponent,
    canActivate: [ AuthGuardService, ContadorGuardService ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'changepass', component: ChanguepassComponent,
    canActivate: [ AuthGuardService ]
  },
  { path: 'nuevogasto', 
    component: NuevogastoComponent,
    canActivate: [ AuthGuardService, MultiUserGuardService]
  },
  { path: 'vergastos', 
    component: VergastosComponent,
    canActivate: [ AuthGuardService, UserGuardService]
  },
  { path: 'verdetalles', 
    component: VerdetallesComponent,
    canActivate: [ AuthGuardService, UserGuardService]
  },
  { path: 'verdetalle', 
    component: VerdetalleComponent,
    canActivate: [ AuthGuardService, UserGuardService]
  },
  { path: 'vergastos-pagos', 
    component: VergastosPagosComponent,
    canActivate: [ AuthGuardService, PagosUserGuardService]
  },
  { path: 'verdetalles-pagos', 
    component: VerdetallesPagosComponent,
    canActivate: [ AuthGuardService, PagosUserGuardService]
  },
  { path: 'vergastos-jorge', 
    component: JorgeComponent,
    canActivate: [ AuthGuardService, JorgeGuardService]
  },
  { path: 'verdetalles-jorge', 
    component: DetallesJorgeComponent,
    canActivate: [ AuthGuardService, JorgeGuardService]
  },
  { path: 'print', 
    component: PrintComponent,
    canActivate: [ AuthGuardService ]
  },
  { path: 'print-gastos', 
    component: PrintGastosComponent,
    canActivate: [ AuthGuardService ]
  },
  { path: 'contador', 
    component: ContadorComponent,
    canActivate: [ AuthGuardService, ContadorGuardService ]
  },
  { path: 'nuevofondofijo', 
  component: NuevofondofijoComponent,
  canActivate: [ AuthGuardService, JorgeGuardService ]
  },
  { path: 'nuevaop', 
  component: NuevaopComponent,
  canActivate: [ AuthGuardService, JorgeGuardService ]
  },
  { path: 'impresionorden', 
  component: ImpresionOpComponent,
  canActivate: [ AuthGuardService, JorgeGuardService ]
  },
  { path: 'verop', 
  component: VeropComponent,
  canActivate: [ AuthGuardService, JorgeGuardService ]
  },
  { path: 'plandecuentas', 
  component: PlandecuentasComponent,
  canActivate: [ AuthGuardService, ContadorGuardService ]
  },
  { path: 'cgimage', 
  component: CGComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'cargar', 
  component: CargaComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'sinomyt', 
  component: SinomytComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'empresas', 
  component: EmpresasComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'consultar', 
  component: ConsultaComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'importador',
  component: ImportadorComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'impo-nominas',
  component: ImportadorallComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'impo-transferencias',
  component: ImportadorallTransfComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'reporte-deudas',
  component: ReporteDeudasComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'reporte-beneficiarios',
  component: ReporteBeneficiariosComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'liquidaciones',
  component: LiquidacionesComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'liquidaciones-guardadas',
  component: LiquidacionesGuardadasComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: 'configuracion',
  component: ConfiguracionComponent,
  canActivate: [ AuthGuardService ]
  },
  { path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    NavbarComponent,
    ReportesComponent,
    LoginComponent,
    NuevogastoComponent,
    VergastosComponent,
    VerdetallesComponent,
    VerdetalleComponent,
    VergastosPagosComponent,
    VerdetallesPagosComponent,
    LoadingComponent,
    CuitInputComponent,
    ChanguepassComponent,
    CategoryFilterPipe,
    JorgeComponent,
    DetallesJorgeComponent,
    PrintComponent,
    PrintGastosComponent,
    ContadorComponent,
    NuevofondofijoComponent,
    NuevaopComponent,
    PlandecuentasComponent,
    ImpresionOpComponent,
    VeropComponent,
    CGComponent,
    CargaComponent,
    EmpresasComponent,
    SinomytComponent,
    ConsultaComponent,
    ImportadorComponent,
    ImportadorallComponent,
    ImportadorallTransfComponent,
    ReporteDeudasComponent,
    ReporteBeneficiariosComponent,
    LiquidacionesComponent,
    LiquidacionesGuardadasComponent,
    CrearEmpresaDialogComponent,
    ConfiguracionComponent,
    PorcentajesComponent,
    VencimientosComponent,
    TextoLegalComponent
  ],
  exports: [
    HomeComponent,
    ReportesComponent,
    LoginComponent
  ],
  imports: [
    WebcamModule,
    NgbModule.forRoot(),
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatPaginatorModule,
    MatIconModule,
    FileUploadModule,
    NgQrScannerModule,
    SpellCheckerModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false, useHash: false } // <-- debugging purposes only
    ),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatToolbarModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatCardModule,
    MatSidenavModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTabsModule,
    MatIconModule,
    MatRadioModule,
    Ng2CarouselamosModule
  ],
  providers: [
    AuthService,
    AuthGuardService,
    UserService,
    UserGuardService,
    MultiUserGuardService,
    AdminGuardService,
    PagosUserGuardService,
    JorgeGuardService,
    ContadorGuardService,
    DatePipe,
    GLOBALService,
    {provide: MAT_DATE_LOCALE, useValue: 'es-AR'},
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
  ],
  entryComponents: [
    CrearEmpresaDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
